// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import SectionItem from "../Shared/SectionItem/SectionItem"
import { renderTechnologyImage } from "Content/Shared/Helpers/Functions/Hooks"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

// REDUX

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  technologies: Array<string>
}

const Technologies: React.FC<PropsType> = (props) => {
  return (
    <SectionItem title={"Technologies"}>
      <Wrapper>
        {props.technologies.map((i) => {
          const image = renderTechnologyImage(i)
          return (
            <Item>
              <Icon src={image} />
              {i}
            </Item>
          )
        })}
      </Wrapper>
    </SectionItem>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
`

const MARGIN_VERTICAL = "10px"
const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: ${MARGIN_VERTICAL};
  margin-bottom: ${MARGIN_VERTICAL};
  font-size: 15px;
`

const ICON_SIZE = "45px"
const Icon = styled.img`
  height: ${ICON_SIZE};
  width: ${ICON_SIZE};
  margin-bottom: 10px;
`

export default React.memo(Technologies, memoComparison)
